import { Link } from 'react-router-dom'

const NEWSLETTER_SUBMIT_URL = 'http://tenford.cn/'

export default function Footer() {
  const footerLinks = {
    navigation: [
      { label: '首页', to: '/' },
      { label: '分类导航', to: '/category/romance' },
      { label: '热门推荐', to: '/category/romance' },
      { label: '关于我们', to: '/about' },
    ],
    categories: [
      { label: '浪漫爱情', to: '/category/romance' },
      { label: '热血动作', to: '/category/action' },
      { label: '奇幻冒险', to: '/category/fantasy' },
      { label: 'BL专区', to: '/category/bl' },
      { label: '悬疑惊悚', to: '/category/thriller' },
      { label: '都市剧情', to: '/category/drama' },
    ],
    support: [
      { label: '常见问题', to: '/about' },
      { label: '版权声明', to: '/about' },
      { label: '商务合作', to: '/about' },
      { label: '联系我们', to: '/about' },
    ],
  }

  const socialLinks = [
    { icon: 'ri-links-line', label: '微博', href: '#' },
    { icon: 'ri-wechat-line', label: '微信', href: '#' },
    { icon: 'ri-movie-line', label: 'B站', href: '#' },
    { icon: 'ri-reddit-line', label: '社区', href: '#' },
  ]

  return (
    <footer className="bg-foreground-950 text-background-100" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
              <span className="font-heading text-2xl font-bold text-background-50">
                韩漫
              </span>
              <span className="font-sans text-xs text-background-400 tracking-widest uppercase mt-1">
                HanMan
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              汇聚韩国顶级漫画作品，从浪漫BL到热血动作，每日同步更新最新章节。致力于为中国读者提供正版、高清、极速的韩国漫画阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                  aria-label={link.label}
                >
                  <i className={`${link.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              网站导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              漫画分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              帮助中心
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              订阅更新
            </h4>
            <p className="text-sm text-background-400 mb-3">
              获取最新韩漫更新通知
            </p>
            <form
              className="flex flex-col gap-2"
              id="footer-newsletter-form"
              action={NEWSLETTER_SUBMIT_URL}
              method="POST"
              onSubmit={(e) => {
                e.preventDefault()
                const form = e.currentTarget as HTMLFormElement
                const formData = new FormData(form)
                const honeypot = (formData.get('website_alt') as string || '').trim()
                if (honeypot) {
                  const input = form.querySelector('input[type="email"]') as HTMLInputElement
                  if (input) input.value = ''
                  return
                }
                fetch(NEWSLETTER_SUBMIT_URL, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                })
                  .then(async (res) => {
                    const text = await res.text()
                    const parsed = JSON.parse(text)
                    if (res.ok && parsed?.code === 'OK') {
                      const emailInput = form.querySelector('input[type="email"]') as HTMLInputElement
                      if (emailInput) emailInput.value = ''
                    }
                  })
                  .catch(() => {})
              }}
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                placeholder="输入邮箱地址"
                className="w-full px-4 py-2.5 bg-background-50/10 border border-background-50/20 rounded-lg text-sm text-background-100 placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors duration-200"
                required
              />
              <button
                type="submit"
                className="w-full px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-1.5"
              >
                订阅
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2025 韩漫漫画网站. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <Link to="/about" className="hover:text-background-300 transition-colors duration-200 cursor-pointer">
              隐私政策
            </Link>
            <Link to="/about" className="hover:text-background-300 transition-colors duration-200 cursor-pointer">
              服务条款
            </Link>
            <Link to="/about" className="hover:text-background-300 transition-colors duration-200 cursor-pointer">
              Cookie政策
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}